import { ref } from 'vue'
import { parseGivingRecordYearQuery } from '@/helpers/givingRecord'

const isOpen = ref(false)
const suggestedPeriod = ref<string | null>(null)

/** Shared record-donation modal. An optional tax year pre-fills the date. */
export function useAddDonationModal() {
  const openAddDonationModal = (periodKey?: string) => {
    suggestedPeriod.value = parseGivingRecordYearQuery(periodKey)
    isOpen.value = true
  }

  const closeAddDonationModal = () => {
    isOpen.value = false
    suggestedPeriod.value = null
  }

  return {
    isOpen,
    suggestedPeriod,
    openAddDonationModal,
    closeAddDonationModal,
  }
}
